"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryInfoResponseMapper = void 0;
var DeliveryInfoResponseMapper = /** @class */ (function () {
    function DeliveryInfoResponseMapper(data) {
        this.localData = data;
    }
    DeliveryInfoResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return DeliveryInfoResponseMapper;
}());
exports.DeliveryInfoResponseMapper = DeliveryInfoResponseMapper;
//# sourceMappingURL=DeliveryInfoResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/DeliveryInfoResponseMapper.js
// module id = 2064
// module chunks = 8